import AutocompleteInput from './AutocompleteInput';

export default AutocompleteInput;
